import Dropdown from 'components/ui/dropdown/Dropdown';
import 'components/ui/dropdown/dropdown.scss';
import './tabs_to_dd.scss';

document.addEventListener('DOMContentLoaded', init);

function init() {
	// .tabs-to-dd class > always convert (all screen sizes)
	document
		.querySelectorAll('.elementor-widget-n-tabs.tabs-to-dd')
		.forEach((widget) => init_tabs_dd(widget, false));

	// ff.settings.tabs_to_dropdown > convert all tabs (mobile only)
	if (window.ff?.settings?.tabs_to_dropdown) {
		document
			.querySelectorAll('.elementor-widget-n-tabs:not(.tabs-to-dd)')
			.forEach((widget) => init_tabs_dd(widget, true));
	}
}

let _dd_count = 0;

function init_tabs_dd(widget, mobile_only) {
	const heading = widget.querySelector('.e-n-tabs-heading');
	if (!heading) return;

	const tab_titles = heading.querySelectorAll('.e-n-tab-title');
	if (!tab_titles.length) return;

	const select = build_select(tab_titles);

	const wrap = document.createElement('div');
	wrap.className = 'tabs_to_dd_wrap';
	heading.before(wrap);
	wrap.appendChild(select);

	if (mobile_only) {
		widget.classList.add('tabs-dd-mobile');
	} else {
		heading.style.display = 'none';
	}

	const dropdown = new Dropdown(select);

	dropdown.hooks.on('select', (option) => {
		const tab = tab_titles[parseInt(option.value)];
		if (!tab) return;
		tab.click();
		const panel = widget.querySelector(`#${tab.getAttribute('aria-controls')}`);
		if (panel) {
			panel.querySelectorAll('.elementor-invisible').forEach((el) =>
				el.classList.remove('elementor-invisible'),
			);
		}
	});
}

function build_select(tab_titles) {
	const select = document.createElement('select');
	const uid = `tabs_dd_${_dd_count++}`;
	select.id = uid;
	select.name = uid;

	tab_titles.forEach((tab, i) => {
		const option = document.createElement('option');
		option.value = i;
		option.textContent =
			tab.querySelector('.e-n-tab-title-text')?.textContent?.trim() ??
			tab.textContent.trim();
		if (tab.getAttribute('aria-selected') === 'true') {
			option.selected = true;
		}
		select.appendChild(option);
	});

	return select;
}
